<script>
import { BaseStoryCardElementMixin }
  from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import { useReadStatusStore } from "%/dynamic-component-editor/stores/read-status-store";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import { ELEMENT_PANEL_FOLDER } from "%/dynamic-component-editor/constants/element-panel-folder-names";

const EXAMPLE_PERCENT = 65;

export default {
  name: "CompletionPercentage",
  elementPanelSettings: {
    folder: ELEMENT_PANEL_FOLDER.COMPLETION,
    displayName: "Completion Percentage",
    displayIcon: "mdi:eye-outline",
    elementGroup: "storyElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [BaseStoryCardElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    readPercent() {
      if (this.editMode || this.isPreviewMode) {
        return EXAMPLE_PERCENT;
      }
      return useReadStatusStore().percentByStory[this.storyEntityId]
        ?? this.entity?.readPercent
        ?? 0;
    },
    shouldShowText() {
      return this.editMode || this.readPercent > 0;
    },
    value() {
      return `${this.readPercent}%`;
    },
  },
};
</script>
